import { SORT_OPTIONS } from "../../../utils/constant";

interface ActivitySortDropdownProps {
  sortOrder: "newest" | "oldest" | null;
  onSort: (order: "newest" | "oldest") => void;
  onReset: () => void;
}

const ActivitySortDropdown = ({
  sortOrder,
  onSort,
  onReset,
}: ActivitySortDropdownProps) => (
  <div
    data-sort-dropdown
    className="absolute top-7 right-0 p-3 flex flex-col gap-y-0.5 border border-border-gray dark:border-border-gray-dk bg-pure-white dark:bg-pure-white-dk rounded-lg shadow-popper-blur-effect backdrop-blur-2xl min-w-[210px] z-50"
  >
    {SORT_OPTIONS?.map((option) => {
      const Icon = option?.icon;
      const isActive = sortOrder === option?.id;

      return (
        <div
          key={option?.id}
          className={`flex items-center gap-1 p-2 cursor-pointer hover:bg-hover-effect dark:hover:bg-hover-effect-dk rounded ${
            isActive && "bg-card-highlight dark:bg-card-highlight-dk"
          }`}
          onClick={() => onSort(option?.id as "newest" | "oldest")}
        >
          <Icon className="w-[18px] h-[18px] shrink-0 text-verba-indigo dark:text-verba-indigo-dk" />
          <div className="flex items-center gap-1">
            <p className="text-md font-normal text-heading-text dark:text-heading-text-dk leading-tight">
              {option?.label}
            </p>
            <p className="text-xxs text-gray-placeholder dark:text-gray-placeholder-dk mt-[3px]">
              {option?.subtitle}
            </p>
          </div>
        </div>
      );
    })}
    <div
      className="w-max text-left text-sm font-medium text-verba-blue dark:text-verba-blue-dk pt-2.5 hover:underline cursor-pointer"
      onClick={onReset}
    >
      Reset
    </div>
  </div>
);

export default ActivitySortDropdown;
